import BaseItem from 'owa-mail-store/lib/store/schema/BaseItem';
import getSelectedTableView from './getSelectedTableView';
import { getListViewStore } from '../store/Store';

// TODO: Task 258: Support both message view and conversation view items
export default function getSelectedMailListItems(): BaseItem[] {
    const tableView = getSelectedTableView();
    const items: BaseItem[] = [];

    if (tableView) {
        tableView.selectedItemsIds.forEach((value, selectedItemId) => {
            const item = getListViewStore().conversationItems.get(selectedItemId);

            // Item can be null if we are clearing conversation items, maybe due to notification.
            if (item) {
                items.push(item);
            }
        });
    }

    return items;
}
